module.exports = __webpack_public_path__ + "media/assets/socials/edm-182b5a9ea101ef407234d73a50fca6df.svg";